const TYPE_OPTIONS = [
    { value: 'call', label: 'Bellen' },
    { value: 'email', label: 'Mailen' },
    { value: 'sms', label: 'SMS' },
    { value: 'visit', label: 'Bezoek' },
]

const OUTCOME_OPTIONS = [
    { value: 'reached', label: 'Bereikt' },
    { value: 'voicemail', label: 'Voicemail ingesproken' },
    { value: 'no-answer', label: 'Geen gehoor' },
    { value: 'refused', label: 'Geweigerd' },
    { value: 'moved', label: 'Verhuisd' },
    { value: 'other', label: 'Overig' },
]

const TYPE_LABELS = TYPE_OPTIONS.reduce((acc, o) => {
    acc[o.value] = o.label
    return acc
}, {})

const OUTCOME_LABELS = OUTCOME_OPTIONS.reduce((acc, o) => {
    acc[o.value] = o.label
    return acc
}, {})

export { TYPE_OPTIONS, OUTCOME_OPTIONS, TYPE_LABELS, OUTCOME_LABELS }
